import { useState } from "react";
import { toast } from "sonner";
import { socialPulseEnabled, startSocialPulseLogin } from "@/lib/socialpulseOidc";

// Continue-with-SocialPulse pill. Renders only when REACT_APP_SOCIALPULSE_OIDC_ISSUER
// is set — silent no-op otherwise so preview builds don't show a dead button.

export default function ContinueWithSocialPulse({ returnTo = "/", disabled = false }) {
  const [busy, setBusy] = useState(false);
  if (!socialPulseEnabled()) return null;

  const onClick = async () => {
    setBusy(true);
    try {
      await startSocialPulseLogin({ returnTo });
    } catch (e) {
      setBusy(false);
      toast.error(e?.message || "Could not start SocialPulse sign-in");
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy || disabled}
      data-testid="continue-with-socialpulse-btn"
      className="w-full inline-flex items-center justify-center gap-3 rounded-full px-5 py-3 font-mono-tech text-[11px] tracking-[0.3em] uppercase text-white bg-gradient-to-r from-[#6E3AD6] via-[#8E4EF0] to-[#B072FF] hover:opacity-90 disabled:opacity-40 shadow-[0_1px_0_rgba(255,255,255,0.25)_inset,0_8px_24px_rgba(110,58,214,0.35)]"
    >
      {/* Inline SocialPulse mark — no external asset needed */}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.15)" />
        <path d="M6 12c3-4 9-4 12 0-3 4-9 4-12 0z" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="12" r="1.6" fill="#fff" />
      </svg>
      {busy ? "Redirecting…" : "Continue with SocialPulse"}
    </button>
  );
}
